import React from "react";
import styles from "../../styles/presentational/busy.css";

export class Busy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.busy}>
          <div />
          <div />
          <div />
        </div>
      </div>
    );
  }
}
